/**
 * Module-level Noodl context storage for API client
 * This allows the Client class to access Noodl's cloud services metadata
 */

// Store Noodl context reference (set by the node on initialize)
let _noodlContext: {
  graphModel?: {
    getMetaData: (key: string) => {
      appId?: string;
      workspaceId?: string;
      instanceId?: string;
      endpoint?: string;
    } | undefined;
  };
} | null = null;

export function setNoodlContext(context: typeof _noodlContext) {
  _noodlContext = context;
}

export function getNoodlContext() {
  return _noodlContext;
}
